import type { PropsWithChildren } from "react";
import { forwardRef, useCallback } from "react";

import type { InputBaseComponentProps } from "@mui/material";
import { NumericFormat } from "react-number-format";
import type { NumberFormatValues, SourceInfo } from "react-number-format";

import type { OnMetricChangeFn } from "../DataEntryInput.types";

type NumberFormatCustomProps = InputBaseComponentProps & { onValueChange?: OnMetricChangeFn };

const NumberFormatCustom = forwardRef<HTMLInputElement, PropsWithChildren<NumberFormatCustomProps>>(
  // eslint-disable-next-line react/prop-types
  ({ onValueChange, ...props }, ref) => {
    const handleValueChange = useCallback(
      (values: NumberFormatValues, sourceInfo: SourceInfo) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (sourceInfo.source === "event") {
          const onMetricChange = onValueChange as OnMetricChangeFn | undefined;
          onMetricChange?.(values.value);
        }
      },
      [onValueChange],
    );

    return (
      <NumericFormat
        {...props}
        getInputRef={ref}
        defaultValue=""
        onValueChange={handleValueChange}
        data-lpignore="true" // LastPass-specific ignore flag
        data-form-type="other" // newer LP heuristic override
        thousandSeparator
        valueIsNumericString
        prefix=""
        fixedDecimalScale
      />
    );
  },
);

NumberFormatCustom.displayName = "NumberFormatCustom";

export default NumberFormatCustom;
